/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getBloodBanks } from 'app/entities/blood-bank/blood-bank.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';
import { RhType } from 'app/shared/model/enumerations/rh-type.model';
import { BloodProducts } from 'app/shared/model/enumerations/blood-products.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';
import { createEntity, getEntity, reset, updateEntity } from './blood-bank-request.reducer';

export const BloodBankRequestUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const bloodBanks = useAppSelector(state => state.bloodBank.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const bloodBankRequestEntity = useAppSelector(state => state.bloodBankRequest.entity);
  const loading = useAppSelector(state => state.bloodBankRequest.loading);
  const updating = useAppSelector(state => state.bloodBankRequest.updating);
  const updateSuccess = useAppSelector(state => state.bloodBankRequest.updateSuccess);
  const bloodGroupValues = Object.keys(BloodGroup);
  const rhTypeValues = Object.keys(RhType);
  const bloodProductsValues = Object.keys(BloodProducts);
  const addedByTypeValues = Object.keys(AddedByType);
  const entityTypeValues = Object.keys(EntityType);

  const handleClose = () => {
    navigate(`/blood-bank-request${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getBloodBanks({}));
    dispatch(getGlucoUsers({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.requestedDate !== undefined && typeof values.requestedDate !== 'number') {
      values.requestedDate = Number(values.requestedDate);
    }
    if (values.dispatchedDate !== undefined && typeof values.dispatchedDate !== 'number') {
      values.dispatchedDate = Number(values.dispatchedDate);
    }
    if (values.unitsRequested !== undefined && typeof values.unitsRequested !== 'number') {
      values.unitsRequested = Number(values.unitsRequested);
    }
    if (values.unitsDispatched !== undefined && typeof values.unitsDispatched !== 'number') {
      values.unitsDispatched = Number(values.unitsDispatched);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...bloodBankRequestEntity,
      ...values,
      bank: bloodBanks.find(it => it.id.toString() === values.bank?.toString()),
      forPatient: glucoUsers.find(it => it.id.toString() === values.forPatient?.toString()),
      status: clinicalDictionaries.find(it => it.id.toString() === values.status?.toString()),
      productComponent: clinicalDictionaries.find(it => it.id.toString() === values.productComponent?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          bloodType: 'O_POS',
          rhType: 'POSITIVE_STRONG',
          productType: 'WB',
          requesterType: 'ACCOUNTANT',
          entityType: 'LAB',
          ...bloodBankRequestEntity,
          bank: bloodBankRequestEntity?.bank?.id,
          forPatient: bloodBankRequestEntity?.forPatient?.id,
          status: bloodBankRequestEntity?.status?.id,
          productComponent: bloodBankRequestEntity?.productComponent?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.bloodBankRequest.home.createOrEditLabel" data-cy="BloodBankRequestCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.bloodBankRequest.home.createOrEditLabel">Create or edit a BloodBankRequest</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="blood-bank-request-id"
                  label={translate('tinyMedicRestApp.bloodBankRequest.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.bloodType')}
                id="blood-bank-request-bloodType"
                name="bloodType"
                data-cy="bloodType"
                type="select"
              >
                {bloodGroupValues.map(bloodGroup => (
                  <option value={bloodGroup} key={bloodGroup}>
                    {translate(`tinyMedicRestApp.BloodGroup.${bloodGroup}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.rhType')}
                id="blood-bank-request-rhType"
                name="rhType"
                data-cy="rhType"
                type="select"
              >
                {rhTypeValues.map(rhType => (
                  <option value={rhType} key={rhType}>
                    {translate(`tinyMedicRestApp.RhType.${rhType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.productType')}
                id="blood-bank-request-productType"
                name="productType"
                data-cy="productType"
                type="select"
              >
                {bloodProductsValues.map(bloodProducts => (
                  <option value={bloodProducts} key={bloodProducts}>
                    {translate(`tinyMedicRestApp.BloodProducts.${bloodProducts}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.requestedDate')}
                id="blood-bank-request-requestedDate"
                name="requestedDate"
                data-cy="requestedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.dispatchedDate')}
                id="blood-bank-request-dispatchedDate"
                name="dispatchedDate"
                data-cy="dispatchedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.unitsRequested')}
                id="blood-bank-request-unitsRequested"
                name="unitsRequested"
                data-cy="unitsRequested"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.unitsDispatched')}
                id="blood-bank-request-unitsDispatched"
                name="unitsDispatched"
                data-cy="unitsDispatched"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.reason')}
                id="blood-bank-request-reason"
                name="reason"
                data-cy="reason"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.requesterId')}
                id="blood-bank-request-requesterId"
                name="requesterId"
                data-cy="requesterId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.requesterType')}
                id="blood-bank-request-requesterType"
                name="requesterType"
                data-cy="requesterType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.active')}
                id="blood-bank-request-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.cursor')}
                id="blood-bank-request-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.lastUpdated')}
                id="blood-bank-request-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.microSec')}
                id="blood-bank-request-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.timestampEntry')}
                id="blood-bank-request-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.transfused')}
                id="blood-bank-request-transfused"
                name="transfused"
                data-cy="transfused"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.ipNumber')}
                id="blood-bank-request-ipNumber"
                name="ipNumber"
                data-cy="ipNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.indications')}
                id="blood-bank-request-indications"
                name="indications"
                data-cy="indications"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.uhid')}
                id="blood-bank-request-uhid"
                name="uhid"
                data-cy="uhid"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.entityType')}
                id="blood-bank-request-entityType"
                name="entityType"
                data-cy="entityType"
                type="select"
              >
                {entityTypeValues.map(entityType => (
                  <option value={entityType} key={entityType}>
                    {translate(`tinyMedicRestApp.EntityType.${entityType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankRequest.entityId')}
                id="blood-bank-request-entityId"
                name="entityId"
                data-cy="entityId"
                type="text"
              />
              <ValidatedField
                id="blood-bank-request-bank"
                name="bank"
                data-cy="bank"
                label={translate('tinyMedicRestApp.bloodBankRequest.bank')}
                type="select"
              >
                <option value="" key="0" />
                {bloodBanks
                  ? bloodBanks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-bank-request-forPatient"
                name="forPatient"
                data-cy="forPatient"
                label={translate('tinyMedicRestApp.bloodBankRequest.forPatient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-bank-request-status"
                name="status"
                data-cy="status"
                label={translate('tinyMedicRestApp.bloodBankRequest.status')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-bank-request-productComponent"
                name="productComponent"
                data-cy="productComponent"
                label={translate('tinyMedicRestApp.bloodBankRequest.productComponent')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/blood-bank-request" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BloodBankRequestUpdate;
